<template>
  <section>
    <qx-search-box
      ref="searchBox"
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  servicerSelectList,
} from 'api/service';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        serviceUserIdOptions: [], // 归属服务商
        form: [
          { // 产品名称
            label: '产品名称',
            value: 'productName',
            type: 'input',
            placeholder: '请输入产品名称',
          },
          { // 服务电话
            label: '服务电话',
            value: 'serviceCall',
            type: 'input',
            placeholder: '请输入服务电话',
          },
          { // 服务地址
            label: '服务地址',
            value: 'address',
            type: 'input',
            placeholder: '请输入服务地址',
          },
          { // 归属服务商
            label: '归属服务商',
            value: 'serviceUserId',
            type: 'select',
            default: this.$route.query.serviceUserId ? Number(this.$route.query.serviceUserId) : '',
            placeholder: '请输入归属服务商',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      this.$refs.tableBox.saveSearchBoxData();
    },
  },
  async created () {
    this.searchBoxData.serviceUserIdOptions = await servicerSelectList();
  },
};
</script>

<style lang="scss" scoped>
</style>
